import { Pagination } from '@/components/common'
import { Box, Grid } from '@mui/material'
import { useSearchParams } from 'next/navigation'
import { ProductItem } from '../product-item'
import { ProductItemComming } from '../product-item-comming'

interface ProductGridProps {
  products: IProducts
  direction: Direction
  onPageChange: (page: number) => void
  showSetItems?: boolean
  productsComingSoon?: ProductComming[]
  showPagination?: boolean
  isMappingColor?: boolean // Có loop để tạo ra nhiều sản phẩm theo màu hay không
  selectedColorFilters?: string[]
}

export const ProductGrid = ({
  products,
  direction,
  onPageChange,
  showSetItems = true,
  productsComingSoon = [],
  showPagination = true,
  isMappingColor = true,
  selectedColorFilters = [],
}: ProductGridProps) => {
  return (
    <>
      <Grid container spacing={{ xs: 1, md: 2 }} columns={24}>
        {products?.items?.map((el, index) => {
          const listColor = el?.configurable_options?.find(
            (option) => option.attribute_code === 'color'
          )?.values

          let listVariantWithColor = listColor
            ?.map((color) => {
              return el?.variants?.find((variant) => {
                return variant?.attributes?.some((attr) => attr.code === 'color' && attr.uid === color.uid)
              })
            })
            .filter(Boolean)

          // Nếu có filter màu, chỉ hiển thị các variant có màu nằm trong filter
          if (selectedColorFilters.length > 0 && listVariantWithColor) {
            listVariantWithColor = listVariantWithColor.filter((variant) => {
              const colorAttr = variant?.attributes?.find((attr) => attr.code === 'color')
              return colorAttr?.label && selectedColorFilters.includes(colorAttr.label)
            })
          }

          // Nếu có variants theo màu, render mỗi màu như 1 sản phẩm riêng
          if (listVariantWithColor && listVariantWithColor.length > 0 && isMappingColor) {
            return listVariantWithColor.map((variant, variantIndex) => {
              // Lấy UID của màu từ variant
              const colorAttr = variant?.attributes?.find((attr) => attr.code === 'color')
              const colorUid = colorAttr?.uid

              return (
                <Grid
                  size={
                    direction !== 'GRID'
                      ? 24
                      : {
                          xs: 12,
                          sm: 8,
                          lg: 6,
                        }
                  }
                  key={`${el?.uid}-${variant?.product?.uid}-${variantIndex}-${direction}`}
                >
                  <ProductItem
                    cardProps={{
                      sx: {
                        minWidth: 'unset',
                      },
                    }}
                    product={el}
                    showSetItems={showSetItems}
                    defaultColorUid={colorUid} // Truyền UID màu để set làm default
                    showColors={false} // Ẩn bộ chọn màu vì mỗi card đại diện 1 màu
                  />
                </Grid>
              )
            })
          }

          // Fallback: Nếu không có variants, render sản phẩm bình thường
          return (
            <Grid
              size={
                direction !== 'GRID'
                  ? 24
                  : {
                      xs: 12,
                      sm: 8,
                      lg: 6,
                    }
              }
              key={el?.uid + index + direction}
            >
              <ProductItem
                cardProps={{
                  sx: {
                    minWidth: 'unset',
                  },
                }}
                product={el}
                showColors={!isMappingColor}
                showSetItems={showSetItems}
              />
            </Grid>
          )
        })}
        {productsComingSoon && productsComingSoon?.length > 0 && (
          <>
            {productsComingSoon?.map((el, index) => (
              <Grid
                size={
                  direction !== 'GRID'
                    ? 24
                    : {
                        xs: 12,
                        sm: 8,
                        lg: 6,
                      }
                }
                key={el?.id}
              >
                <ProductItemComming
                  cardProps={{
                    sx: {
                      minWidth: 'unset',
                    },
                  }}
                  product={el}
                />
              </Grid>
            ))}
          </>
        )}
      </Grid>

      {showPagination && (
        <Pagination
          total={products?.page_info?.page_size * products?.page_info?.total_pages || 0}
          defaultCurrent={products?.page_info?.current_page}
          pageSize={products?.page_info?.page_size}
          onChange={onPageChange}
          sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}
        />
      )}
    </>
  )
}
